import { createFileRoute } from '@tanstack/react-router'
import { ApprovalDetailPage } from '../-components/approval-detail-page'

export const Route = createFileRoute('/mrgolisoda/more/day-end-approvals/$approvalId/')({
  component: function ApprovalDetailWrapper() {
    const { approvalId } = Route.useParams()
    return <ApprovalDetailPage approvalId={approvalId} />
  },
})
